import api from './axios'

export interface MarcaItem {
  marca: string
  cod_cats: string[]
  categorias: string[]
  rotulo: string
}

let marcasCache: MarcaItem[] | null = null

export const carregarMarcas = async (forceRefresh = false): Promise<MarcaItem[]> => {
  if (!forceRefresh && marcasCache && marcasCache.length > 0) {
    return marcasCache
  }

  try {
    const res = await api.get('/marcas')
    const data = Array.isArray(res.data) ? res.data : []
    marcasCache = data
    return data
  } catch (err) {
    console.error('Erro ao carregar marcas:', err)
    return []
  }
}
